export default __webpack_public_path__ + "static/media/coffee.608c5ab0.png";